import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './wpbbsa-calculator-form-v2.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
import * as _ from 'lodash';
var WpbbsaCalculatorFormV2 = /** @class */ (function (_super) {
    tslib_1.__extends(WpbbsaCalculatorFormV2, _super);
    function WpbbsaCalculatorFormV2(element) {
        var _this = _super.call(this, element) || this;
        _this.timeout = null;
        _this.formValid = false;
        _this.isMobileView = false;
        _this.isMobileCalculate = false;
        _this.focusinInitialValue = '0';
        return _this;
    }
    WpbbsaCalculatorFormV2.prototype.init = function () {
        this.inputs = Array.from(this.element.querySelectorAll('input, select'));
        this.modifiers = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modifier'));
        this.modifierToggles = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modifier-toggle'));
        this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-radio-group'));
        this.addonToggles = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-addon-toggle'));
        this.calculatorSubmit = this.element.querySelector('.js-wpbbsa-calculator-calculate');
        this.calculatorReset = this.element.querySelector('.js-wpbbsa-calculator-reset');
        this.calculatorMain = this.element.closest('.wpbbsa-calculators-v2');
        this.calculatorItem = this.element.closest('.wpbbsa-calculator-item-v2');
        this.calculatorInfo = this.calculatorItem.querySelector('.wpbbsa-calculator-item-v2__box--gradient-blue');
        this.calculator = this.element.querySelector('form');
        this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));
        this.sliders = Array.from(this.element.querySelectorAll('.wpbbsa-calculator-form-v2__input--range'));
        this.modalLinks = Array.from(this.element.querySelectorAll('.js-wpbbsa-calculator-modal'));
        this.termChecker = Array.from(this.element.querySelectorAll('select[name=term]'));
        // -- Application Types For Home Loan Switch -- //
        this.applicationTypes = Array.from(this.element.querySelectorAll('.content-list-with-category__chips--item'));
        if (this.applicationTypes) {
            if (this.applicationTypes.length > 0) {
                var activeItem = this.element.querySelector(".content-list-with-category__chips--item.active");
                if (activeItem != null && activeItem.id === "preferential") {
                    this.singleApplicationType = true;
                }
            }
        }
        this.checkIfMobile();
        this.initialiseSliders();
        TooltipsService.initTooltips();
        // -- INITIALIZE CALCULATORS -- //
        // -- INITIALIZE ARMOTISATION CALCULATOR -- //
        this.amortisationCalculator = this.wpbbsaCalculatorService.initializeWpbbsaCalculator(this.calculator);
        if (this.amortisationCalculator) {
            this.amortisationCalculator.bindEvents();
        }
        // -- INITIALIZE STUDENT LOANS QUOTE FORM -- //
        var studentLoanQuoteForm = this.element.querySelector("div[data-component='form-item-student-loans-quote']");
        if (studentLoanQuoteForm) {
            this.analyticsFormData();
        }
        this.personToPay = this.element.querySelector("select[name=\"person-to-pay-loan\"]");
        this.studentLoanTerm = this.element.querySelector("input[name=\"sl_loan_term\"]");
    };
    WpbbsaCalculatorFormV2.prototype.bindEvents = function () {
        var _this = this;
        // Trigger correct UI view (mobile / desktop) for on window resize
        window.addEventListener('resize', _.debounce(function () {
            _this.checkIfMobile();
        }, 500));
        if (this.personToPay) {
            this.personToPay.addEventListener('change', function (event) {
                _this.isMobileCalculate = false;
                _this.hideDisplayLoanTerm(event.currentTarget.value);
                _this.toggleActionButtons();
                _this.checkIfMobile();
            });
        }
        if (this.calculatorSubmit) {
            this.calculatorSubmit.addEventListener('click', function (event) {
                _this.formValid = _this.wpbbsaCalculatorService.validateWpbbsaCalculatorAllFields(_this.inputs, _this.calculatorSubmit);
                var _valid = Array.from(_this.element.querySelectorAll('.wpbbsa-calculator-form-v2__error'));
                if (_this.formValid && _valid.length <= 0) {
                    // Do calculations
                    _this.wpbbsaCalculatorService.detect(_this.calculator);
                    // animate back to top and display mobile calculations
                    if ($(window).width() < 768) {
                        _this.isMobileCalculate = true;
                        _this.checkIfMobile();
                        // top of calculator information
                        $('html,body').animate({
                            scrollTop: $(_this.calculatorInfo).offset().top - 100
                        }, 'slow');
                    }
                }
                else {
                    // Analytics - Trigger form Complete when the user calculates the results
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields| norequest");
                    // scroll to error
                    if ($(window).width() < 768) {
                        $('html,body').animate({
                            scrollTop: $(_valid[0]).offset().top - 100
                        }, 'slow');
                    }
                }
            });
        }
        this.inputs.map(function (item) { return item.addEventListener('change', function (event) {
            _this.formValid = _this.wpbbsaCalculatorService.validateWpbbsaCalculator(event, _this.calculator);
            var _valid = Array.from(_this.element.querySelectorAll('.wpbbsa-calculator-form-v2__error'));
            if ($(window).width() > 768) {
                _this.isMobileView = false;
            }
            else {
                _this.isMobileView = true;
            }
            if (_this.formValid && _valid.length <= 0) {
                if (_this.isMobileView == true) {
                    if (_this.calculatorSubmit) {
                        _this.calculatorSubmit.classList.remove('button--disabled');
                    }
                }
                else {
                    if (_this.calculatorSubmit) {
                        _this.calculatorSubmit.classList.add('button--disabled');
                    }
                    _this.wpbbsaCalculatorService.detect(_this.calculator);
                }
            }
            else {
                if (_this.calculatorSubmit) {
                    _this.calculatorSubmit.classList.add('button--disabled');
                }
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields| norequest");
            }
        }); });
        this.modifiersRadiosToggle.map(function (item) { return item.addEventListener('click', function (event) {
            var targetField = event.target;
            var visibleGroups = Array.from(_this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
            var radioContainers = Array.from(_this.element.querySelectorAll('.js-wpbbsa-calculator-radio-group-containers'));
            radioContainers.map(function (item) {
                item.classList.add('wpbbsa-calculators-v2__hidden');
                var inputs = Array.from(item.querySelectorAll('input'));
                inputs.map(function (item) {
                    var getDefaultValue = item.value;
                    if (!getDefaultValue == undefined || getDefaultValue == '') {
                        item.value = '';
                    }
                    else {
                        item.value = getDefaultValue;
                    }
                });
            });
            visibleGroups.map(function (item) {
                item.classList.remove('wpbbsa-calculators-v2__hidden');
            });
        }); });
        // -- Application Types selection for Home Loan Switch -- //
        if (this.applicationTypes) {
            if (this.applicationTypes.length > 0) {
                this.applicationTypes.map(function (applicationType) {
                    applicationType.addEventListener("click", function (pEvent) {
                        _this.applicationTypes.forEach(function (applicationTypeItem) {
                            applicationTypeItem.classList.remove("active");
                        });
                        var _target = pEvent.currentTarget;
                        if (_target) {
                            _target.classList.add("active");
                            switch (_target.id) {
                                case "single":
                                    _this.singleApplicationType = true;
                                    break;
                                default:
                                    _this.singleApplicationType = false;
                                    break;
                            }
                        }
                    });
                });
            }
        }
        if (this.calculatorReset) {
            this.calculatorReset.addEventListener('click', function (event) {
                _this.resetInputs(event);
            });
        }
        this.modifierToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleModifiers(event);
        }); });
        this.addonToggles.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleAddons(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('input', function (event) {
            _this.copyField(event);
        }); });
        this.copyFields.map(function (item) { return item.addEventListener('change', function (event) {
            _this.copyFieldChange(event);
        }); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModal(event);
        }); });
        // INPUTS
        this.inputs.map(function (item) { return item.addEventListener('focusin', function (event) {
            _this.onFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('focusout', function (event) {
            _this.outFocusInput(event);
        }); });
        this.inputs.map(function (item) { return item.addEventListener('keyup', function (event) {
            _this.keyInput(event);
        }); });
        if (this.termChecker) {
            this.termChecker.map(function (item) { return item.addEventListener('change', function (event) {
                _this.checkBaloonPayments(event);
            }); });
        }
        // DATE PICKER
        $(document).ready(function () {
            if ($('input.js-date-picker')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker', datePickerConfig);
            }
            if ($('input.js-date-picker-full')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-full', datePickerConfig);
            }
            function instantiateDate(pSelector, pConfig) {
                $('input' + pSelector).datepicker(pConfig).on('changeDate', function (event) {
                    var _event;
                    if (typeof window.event === 'function') {
                        _event = new Event('change');
                        this.dispatchEvent(_event);
                    }
                    else {
                        _event = document.createEvent('HTMLEvents');
                        _event.initEvent('change', false, false);
                        this.dispatchEvent(_event);
                    }
                });
            }
        });
    };
    // -- INITIALIZE STUDENT LOANS ANALYTICS -- //
    WpbbsaCalculatorFormV2.prototype.analyticsFormData = function () {
        dataLayer.pageName = "personal:products and services:borrow for your needs:student loans:calculator";
        dataLayer.application.applicationName = "application: student loans";
        dataLayer.application.applicationProduct = "Student Loan";
        dataLayer.application.applicationMethod = "online";
        dataLayer.application.applicationStart = true;
        dataLayer.application.applicationComplete = false;
    };
    // -- STUDENT LOANS QUOTE FORM UTIL FUNCTIONS -- //
    WpbbsaCalculatorFormV2.prototype.hideDisplayLoanTerm = function (personToPay) {
        if (this.studentLoanTerm) {
            if (personToPay === 'STUDENT' || personToPay === "NOONE") {
                this.studentLoanTerm.closest('.form__group').classList.remove('form__group--hidden');
            }
            else if (personToPay === "SURETY") {
                this.studentLoanTerm.closest('.form__group').classList.add('form__group--hidden');
            }
            else {
                this.studentLoanTerm.closest('.form__group').classList.remove('form__group--hidden');
            }
        }
    };
    WpbbsaCalculatorFormV2.prototype.toggleActionButtons = function () {
        var applyNowBtn = this.calculatorInfo.querySelector('.js-wpbbsa-calculator-view-quote');
        var selectedPersonToPay = this.personToPay.options[this.personToPay.selectedIndex].value;
        if (applyNowBtn) {
            if (selectedPersonToPay === 'NOONE') {
                applyNowBtn['text'] = 'Apply now';
                applyNowBtn['href'] = '/southafrica/personal/products-and-services/borrow-for-your-needs/student-loans/student-loans/student-loans-without-surety-application';
                applyNowBtn.removeAttribute('data-modal');
                applyNowBtn.setAttribute('target', '_blank');
                applyNowBtn.setAttribute('data-text', 'student loans calculator | apply now button click');
            }
            else {
                applyNowBtn['text'] = 'Do I qualify';
                applyNowBtn['href'] = 'javascript:void(0);';
                applyNowBtn.removeAttribute('target');
                applyNowBtn.setAttribute('data-modal', 'form-container-student-loans-quote');
                applyNowBtn.setAttribute('data-text', 'student loans calculator | do I qualify button click');
            }
        }
    };
    WpbbsaCalculatorFormV2.prototype.updateSlider = function (event) {
        var field = event.target;
        if (field.type === 'range') {
            var value = (field.value - field.min) / (field.max - field.min) * 100;
            var styleVal = value + '%';
            event.target.style.setProperty('--range-bg-color-percent', styleVal);
        }
    };
    WpbbsaCalculatorFormV2.prototype.initialiseSliders = function () {
        this.sliders.forEach(function (element) {
            var value = (element.value - element.min) / (element.max - element.min) * 100;
            var styleVal = value + '%';
            element.style.setProperty('--range-bg-color-percent', styleVal);
        });
    };
    WpbbsaCalculatorFormV2.prototype.checkIfMobile = function () {
        if ($(window).width() > 768) {
            if (this.calculatorSubmit) {
                this.calculatorSubmit.classList.add('wpbbsa-calculators-v2__hidden');
            }
            if (this.calculatorInfo) {
                this.calculatorInfo.classList.remove('hidden');
            }
            this.isMobileView = false;
        }
        else {
            if (this.calculatorSubmit) {
                this.calculatorSubmit.classList.remove('wpbbsa-calculators-v2__hidden');
            }
            if (this.calculatorInfo) {
                if (this.isMobileCalculate) {
                    this.calculatorInfo.classList.remove('hidden');
                }
                else {
                    this.calculatorInfo.classList.add('hidden');
                }
            }
            this.isMobileView = true;
        }
    };
    WpbbsaCalculatorFormV2.prototype.openModal = function (event) {
        var modalId = event.currentTarget.parentNode.getAttribute('data-modal');
        this.event.emit('openModal', {
            id: modalId
        });
    };
    WpbbsaCalculatorFormV2.prototype.copyField = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.target.parentNode);
        var copyValueStr = '';
        var copyValueNum = 0;
        if (event.target.value !== '') {
            copyValueNum = Number.parseFloat(event.target.value);
            var _tmpValue = String(event.target.value).split('.');
            if (_tmpValue.length > 1) {
                if (_tmpValue[1].length > 2) {
                    copyValueStr = Number.parseFloat(event.target.value).toFixed(2);
                }
            }
        }
        var fieldName = fieldParentContainer.getAttribute('data-target');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValueNum === 0) {
                    copyValueNum = 1;
                }
            }
            fields[i].value = copyValueNum;
        }
        // Form form start (if not started yet) when slider is being interacted with
        this.analyticsService.dtmTriggerFormStart(fields[0]);
    };
    WpbbsaCalculatorFormV2.prototype.copyFieldChange = function (event) {
        var fieldParentContainer = this.findFieldCopy(event.target.parentNode);
        var copyValueString = event.target.value;
        var copyValueNum = Number.parseFloat(copyValueString);
        var copyValue = '';
        if ((event.target.getAttribute('type') === 'text' || event.target.getAttribute('type') === 'number')
            && event.target.getAttribute('data-validation-title') === 'percent') {
            copyValue = this.focusinInitialValue;
            if (copyValueString.includes('.')) {
                var _tmpValue = String(event.target.value).split('.');
                if (_tmpValue.length > 1) {
                    if (_tmpValue[1].length > 2) {
                        if (!isNaN(copyValueNum)) {
                            copyValue = copyValueNum.toFixed(2);
                        }
                    }
                    else if (_tmpValue[1].length > 0) {
                        if (!isNaN(Number.parseFloat(_tmpValue[0])) && !isNaN(Number.parseFloat(_tmpValue[1]))) {
                            copyValue = copyValueString;
                        }
                    }
                    else {
                        if (!isNaN(Number.parseFloat(_tmpValue[0]))) {
                            copyValue = copyValueString;
                        }
                    }
                }
                else {
                    if (!isNaN(copyValueString)) {
                        copyValue = copyValueString;
                    }
                }
            }
        }
        if (copyValueString === '') {
            copyValue = 0;
        }
        var fieldName = fieldParentContainer.getAttribute('data-validation-title');
        var fields = fieldParentContainer.querySelectorAll(".js-" + fieldName);
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].classList.contains('js-not-zero')) {
                if (copyValue === 0) {
                    copyValue = 1;
                }
            }
            fields[i].value = copyValue;
        }
        this.initialiseSliders();
    };
    WpbbsaCalculatorFormV2.prototype.findFieldCopy = function (parent) {
        while (!parent.classList.contains('js-copy-fields')) {
            parent = parent.parentElement;
        }
        return parent;
    };
    WpbbsaCalculatorFormV2.prototype.toggleModifiers = function (event) {
        event.preventDefault();
        var targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetModifier = this.element.querySelector("#" + targetModifierId);
        if (targetModifier.classList.contains('wpbbsa-calculator-form-v2__modifiers--open')) {
            targetModifier.classList.remove('wpbbsa-calculator-form-v2__modifiers--open');
            event.currentTarget.classList.add('wpbbsa-calculator-form-v2__link--open');
        }
        else {
            targetModifier.classList.add('wpbbsa-calculator-form-v2__modifiers--open');
            event.currentTarget.classList.remove('wpbbsa-calculator-form-v2__link--open');
        }
    };
    WpbbsaCalculatorFormV2.prototype.toggleAddons = function (event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('link--disabled')) {
            return;
        }
        var targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
        var targetAddon = this.element.querySelector('#' + targetAddonId);
        var targetInput = targetAddon.querySelector('input');
        var _tmpText = event.currentTarget.querySelector('.link__text');
        var _coAppText = this.element.querySelector('.co_app_text');
        if (targetAddon.classList.contains('wpbbsa-calculator-form-v2__addon--open')) {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.remove('wpbbsa-calculator-form-v2__addon--open');
            _tmpText.innerText = '+ Add co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '';
            }
        }
        else {
            if (targetInput) {
                targetInput.value = '0';
                targetInput.placeholder = '0';
            }
            targetAddon.classList.add('wpbbsa-calculator-form-v2__addon--open');
            _tmpText.innerText = '- Remove co-applicant\'s income';
            if (_coAppText) {
                _coAppText.innerText = '(including co-applicant)';
            }
        }
    };
    WpbbsaCalculatorFormV2.prototype.resetInputs = function (event) {
        event.preventDefault();
        var errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
        errorLabels.map(function (item) {
            var parent = item;
            $(parent).removeClass('wpbbsa-calculator-form-v2__error');
            $(parent).find('div.wpbbsa-calculator-form-v2__error-label').remove();
        });
        if ($(window).width() < 768) {
            this.calculatorSubmit.classList.add('button--disabled');
            this.calculatorInfo.classList.add('hidden');
        }
        this.calculator.reset();
        this.formValid = true;
        this.isMobileCalculate = false;
        this.wpbbsaCalculatorService.resetValues(this.calculator);
        this.inputs.map(function (item) {
            if (item.getAttribute('type') !== 'radio') {
                item.setAttribute('data-value', 0);
                item.setAttribute('placeholder', 0);
            }
            if (item.classList.contains('form__datepicker')) {
                item.setAttribute('data-value', '');
                item.setAttribute('placeholder', '');
            }
        });
        this.initialiseSliders();
        // animate back to top of calculator
        $('html,body').animate({
            scrollTop: $(this.calculatorMain).offset().top - 40
        }, 'slow');
        // Analytics - Trigger form Complete when the user calculates the results
        this.analyticsService.dtmRestartForm();
    };
    WpbbsaCalculatorFormV2.prototype.onFocusInput = function (event) {
        event.preventDefault();
        this.focusinInitialValue = event.target.value;
        var field = event.target;
        var numberValue = new RegExp('^[-+]?[0-9]*\.?[0-9]+$');
        if (!numberValue.test(field.value)) {
            var _value = parseFloat(field.value);
            var min = parseFloat(field.getAttribute('min'));
            var max = parseFloat(field.getAttribute('max'));
            if (min && max) {
                if ((_value < min) || (_value > max)) {
                    field.value = '';
                }
            }
            else {
                if (_value === 0) {
                    field.value = '';
                }
            }
        }
    };
    WpbbsaCalculatorFormV2.prototype.outFocusInput = function (event) {
        event.preventDefault();
        var field = event.target;
        if (!field.classList.contains('js-copy-field')) {
            var value = field.getAttribute('data-value');
            if (value) {
                if (field.value === '') {
                    field.value = value;
                }
            }
        }
    };
    WpbbsaCalculatorFormV2.prototype.keyInput = function (event) {
        event.preventDefault();
        this.formValid = true;
        var field = event.target;
        var value = field.value;
        if (!field.classList.contains('js-copy-field')) {
            field.setAttribute('data-value', value);
            field.setAttribute('placeholder', value);
        }
    };
    WpbbsaCalculatorFormV2.prototype.checkBaloonPayments = function (event) {
        var value = event.currentTarget.value;
        var balloonInput = Array.from(this.element.querySelectorAll('.js-balloon'));
        if (balloonInput.length > 0) {
            if (value === '84') {
                balloonInput.forEach(function (element) {
                    element.value = '0';
                    element.placeholder = '0';
                    element.max = '0';
                    element.min = '0';
                    element.setAttribute('data-value', '0');
                });
            }
            else {
                balloonInput.forEach(function (element) {
                    element.value = '1';
                    element.placeholder = '1';
                    element.max = '40';
                    element.min = '1';
                    element.setAttribute('data-value', '1');
                });
            }
        }
    };
    return WpbbsaCalculatorFormV2;
}(Base));
export { WpbbsaCalculatorFormV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/wpbbsa-calculator-form-v2/wpbbsa-calculator-form-v2.component.ts
// module id = 1003
// module chunks = 0